import * as http from 'utils/http';
import config from 'config';

export const postDocumentUpload = (uuid, entity_type, document_type, files) =>
  http.post(`${config.API_URL}documents/upload/`, {
    uuid,
    entity_type,
    document_type,
    ...(files && { files }),
  });

export const postImageUpload = (uuid, entity_type, document_type, image) =>
  http.post(`${config.API_URL}documents/images/`, {
    uuid,
    entity_type,
    document_type,
    ...(image && { image }),
  });

export const deleteImages = (uuid, entity_type, document_type) =>
  http._delete(`${config.API_URL}documents/images/`, { uuid, entity_type, document_type });
